export default __webpack_public_path__ + "static/media/product24_sportshoe.d4ab891a.webp";